<template>
	<span :class="colorClass">
		<pre v-if="event.type === 'error-uncaught'" :class="[wrap ? 'whitespace-pre-wrap break-all' : '']">{{
			event.content.stack || event.content.message
		}}</pre>
		<pre v-else-if="event.type === 'error-promise'" :class="[wrap ? 'whitespace-pre-wrap break-all' : '']">
(in promise) {{ event.content.stack || event.content.message }}</pre
		>
		<template v-else>
			<ConsoleEventArgs :args="event.args" :wrap="wrap"></ConsoleEventArgs>
		</template>
	</span>
</template>
<script>
import ConsoleEventArgs from 'shared/components/ConsoleEventArgs.vue'

export default {
	name: 'ConsoleEventError',
	components: {
		ConsoleEventArgs,
	},
	props: {
		event: Object,
		wrap: {type: Boolean, default: false},
		colorClass: {type: String, default: 'text-error'},
	},
}
</script>
